'use client';

import { c as _c } from "react/compiler-runtime";
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { COMMENTS_SORT_OPTIONS } from '@/app/[locale]/(worlds)/[roomId]/components/CommentsPanel';
import SortIcon from '@/components/assets/icon_sort.svg';
import PopoverMenu from '@/components/PopoverMenu';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover';
import ViverseButton from '@/components/ViverseButton';
import { cn } from '@/lib/utils';
import { SortOptionValue } from '@/types/comments';
type SortPopoverButtonProps = {
  sortOrder: SortOptionValue;
  setSortOrder: (sortOrder: SortOptionValue) => void;
  isRailMode?: boolean;
  portalContainer?: HTMLElement | null;
};
function SortPopoverButton(t0) {
  const $ = _c(52);
  const {
    sortOrder,
    setSortOrder,
    isRailMode: t1,
    portalContainer
  } = t0;
  const isRailMode = t1 === undefined ? false : t1;
  const t = useTranslations();
  const [open, setOpen] = useState(false);
  const t2 = isRailMode ? "min-w-0 p-1.5 px-4" : "gap-2 px-4 py-1.5";
  const t3 = open && "bg-vive-primary-70";
  let t4;
  if ($[0] !== t2 || $[1] !== t3) {
    t4 = cn("flex cursor-pointer items-center bg-transparent", t2, t3);
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = () => setOpen(true);
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const t6 = `sort-popover.item.${COMMENTS_SORT_OPTIONS[sortOrder].label}`;
  let t7;
  if ($[4] !== t || $[5] !== t6) {
    t7 = t(t6);
    $[4] = t;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = open ? "fill-primary" : "fill-vive-primary-20";
  let t9;
  if ($[7] !== t8) {
    t9 = cn("size-4 shrink-0", t8);
    $[7] = t8;
    $[8] = t9;
  } else {
    t9 = $[8];
  }
  let t10;
  if ($[9] !== t9) {
    t10 = <SortIcon className={t9} />;
    $[9] = t9;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isRailMode || $[12] !== open || $[13] !== sortOrder || $[14] !== t) {
    t11 = !isRailMode && <span className={cn("buttonS-omni-styles", open && "text-primary")}>{t(`sort-popover.item.${COMMENTS_SORT_OPTIONS[sortOrder].label}`)}</span>;
    $[11] = isRailMode;
    $[12] = open;
    $[13] = sortOrder;
    $[14] = t;
    $[15] = t11;
  } else {
    t11 = $[15];
  }
  let t12;
  if ($[16] !== t10 || $[17] !== t11 || $[18] !== t4 || $[19] !== t7) {
    t12 = <PopoverTrigger asChild={true}><ViverseButton data-component="comments-sort" className={t4} onClick={t5} variant="filter" aria-label={t7}>{t10}{t11}</ViverseButton></PopoverTrigger>;
    $[16] = t10;
    $[17] = t11;
    $[18] = t4;
    $[19] = t7;
    $[20] = t12;
  } else {
    t12 = $[20];
  }
  let t13;
  if ($[21] !== isRailMode) {
    t13 = isRailMode ? {
      align: "end"
    } : {};
    $[21] = isRailMode;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== setSortOrder) {
    t14 = () => {
      setSortOrder(COMMENTS_SORT_OPTIONS.top.value);
      setOpen(false);
    };
    $[23] = setSortOrder;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t) {
    t15 = t("sort-popover.item.top-comments");
    $[25] = t;
    $[26] = t15;
  } else {
    t15 = $[26];
  }
  let t16;
  if ($[27] !== t15) {
    t16 = <div className="body-1 text-inherit">{t15}</div>;
    $[27] = t15;
    $[28] = t16;
  } else {
    t16 = $[28];
  }
  let t17;
  if ($[29] !== t14 || $[30] !== t16) {
    t17 = <PopoverMenu.Item className="rounded-none" onClick={t14}>{t16}</PopoverMenu.Item>;
    $[29] = t14;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== setSortOrder) {
    t18 = () => {
      setSortOrder(COMMENTS_SORT_OPTIONS.latest.value);
      setOpen(false);
    };
    $[32] = setSortOrder;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] !== t) {
    t19 = t("sort-popover.item.latest");
    $[34] = t;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t19) {
    t20 = <div className="body-1 text-inherit">{t19}</div>;
    $[36] = t19;
    $[37] = t20;
  } else {
    t20 = $[37];
  }
  let t21;
  if ($[38] !== t18 || $[39] !== t20) {
    t21 = <PopoverMenu.Item className="rounded-none" onClick={t18}>{t20}</PopoverMenu.Item>;
    $[38] = t18;
    $[39] = t20;
    $[40] = t21;
  } else {
    t21 = $[40];
  }
  let t22;
  if ($[41] !== t17 || $[42] !== t21) {
    t22 = <PopoverMenu className="bg-vive-primary-70 rounded-[3px] p-2"><PopoverMenu.Group>{t17}{t21}</PopoverMenu.Group></PopoverMenu>;
    $[41] = t17;
    $[42] = t21;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== portalContainer || $[45] !== t13 || $[46] !== t22) {
    t23 = <PopoverContent side="bottom" {...t13} className="mt-2 border-none bg-transparent p-0" portalContainer={portalContainer}>{t22}</PopoverContent>;
    $[44] = portalContainer;
    $[45] = t13;
    $[46] = t22;
    $[47] = t23;
  } else {
    t23 = $[47];
  }
  let t24;
  if ($[48] !== open || $[49] !== t12 || $[50] !== t23) {
    t24 = <><Popover open={open} onOpenChange={setOpen}>{t12}{t23}</Popover></>;
    $[48] = open;
    $[49] = t12;
    $[50] = t23;
    $[51] = t24;
  } else {
    t24 = $[51];
  }
  return t24;
}
export default SortPopoverButton;